<!-- <h1 mat-dialog-title>{{'ALERT_DIALOG.TITLE' | translate}}</h1> -->
<div mat-dialog-content>
  <app-form-component #formComponent readonly="true" [formData]="form"></app-form-component>
</div>
<div mat-dialog-actions align="end">
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        (click)="closeDialog()">
        {{'ALERT_DIALOG.ACCEPT' | translate}}
    </button>
</div>
